import { Timestamp } from 'firebase/firestore';

export class Image {
    id: string = '';
    userId: string = '';
    firebaseUrl: string = '';
    description: string = '';
    created_at: Date = new Date();
    likesCount: number = 0;
    viewsCount: number = 0;

    constructor(init?: Partial<Image>) {
        Object.assign(this, init);
    }

    static fromFirestore(id: string, data: any): Image {
        return new Image({
            id,
            userId: data.userId ?? '',
            firebaseUrl: data.firebaseUrl ?? '',
            description: data.description ?? '',
            created_at: data.created_at instanceof Timestamp ? data.created_at.toDate() : (data.created_at ? new Date(data.created_at) : new Date()),
            likesCount: typeof data.likesCount === 'number' ? data.likesCount : 0,
            viewsCount: typeof data.viewsCount === 'number' ? data.viewsCount : 0
        });
    }

    toFirestore() {
        return {
            userId: this.userId,
            firebaseUrl: this.firebaseUrl,
            description: this.description,
            created_at: this.created_at,
            likesCount: this.likesCount,
            viewsCount: this.viewsCount
        };
    }
}
